import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable()
export class Notification {
    warn(arg0: string) {
      throw new Error('Method not implemented.');
    }
    success(arg0: string) {
      throw new Error('Method not implemented.');
    }
    error(arg0: string) {
      throw new Error('Method not implemented.');
    }
    errormsg: any;
    constructor(private Tost: ToastrService) { }
    successmsg(Msg:string) {
        this.Tost.success(Msg, 'Success')
    }
    errorsmsg(Msg:string) {
         this.Tost.error(Msg,'Error')      
    }


    
}